/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateTaskTabDto } from '../models/work-create-task-tab-dto';
import { WorkTaskTab } from '../models/work-task-tab';
import { WorkUpdateTaskTabDto } from '../models/work-update-task-tab-dto';

@Injectable({ providedIn: 'root' })
export class WorkTaskTabsV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `taskTabsV2ControllerFindRoleTabs()` */
  static readonly TaskTabsV2ControllerFindRoleTabsPath = '/v2/task-tabs/role';

  /**
   * Required permissions: task-tabs:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `taskTabsV2ControllerFindRoleTabs()` instead.
   *
   * This method doesn't expect any request body.
   */
  taskTabsV2ControllerFindRoleTabs$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkTaskTab>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTaskTabsV2Service.TaskTabsV2ControllerFindRoleTabsPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkTaskTab>>;
      })
    );
  }

  /**
   * Required permissions: task-tabs:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `taskTabsV2ControllerFindRoleTabs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  taskTabsV2ControllerFindRoleTabs(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkTaskTab>> {
    return this.taskTabsV2ControllerFindRoleTabs$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkTaskTab>>): Array<WorkTaskTab> => r.body)
    );
  }

  /** Path part for operation `taskTabsV2ControllerCreateRoleTab()` */
  static readonly TaskTabsV2ControllerCreateRoleTabPath = '/v2/task-tabs/role';

  /**
   * Required permissions: task-tabs:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `taskTabsV2ControllerCreateRoleTab()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  taskTabsV2ControllerCreateRoleTab$Response(
    params: {
      body: WorkCreateTaskTabDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTaskTab>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTaskTabsV2Service.TaskTabsV2ControllerCreateRoleTabPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTaskTab>;
      })
    );
  }

  /**
   * Required permissions: task-tabs:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `taskTabsV2ControllerCreateRoleTab$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  taskTabsV2ControllerCreateRoleTab(
    params: {
      body: WorkCreateTaskTabDto
    },
    context?: HttpContext
  ): Observable<WorkTaskTab> {
    return this.taskTabsV2ControllerCreateRoleTab$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTaskTab>): WorkTaskTab => r.body)
    );
  }

  /** Path part for operation `taskTabsV2ControllerDeleteRoleTab()` */
  static readonly TaskTabsV2ControllerDeleteRoleTabPath = '/v2/task-tabs/role/{id}';

  /**
   * Required permissions: task-tabs:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `taskTabsV2ControllerDeleteRoleTab()` instead.
   *
   * This method doesn't expect any request body.
   */
  taskTabsV2ControllerDeleteRoleTab$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTaskTabsV2Service.TaskTabsV2ControllerDeleteRoleTabPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: task-tabs:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `taskTabsV2ControllerDeleteRoleTab$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  taskTabsV2ControllerDeleteRoleTab(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.taskTabsV2ControllerDeleteRoleTab$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `taskTabsV2ControllerUpdateRoleTab()` */
  static readonly TaskTabsV2ControllerUpdateRoleTabPath = '/v2/task-tabs/role/{id}';

  /**
   * Required permissions: task-tabs:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `taskTabsV2ControllerUpdateRoleTab()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  taskTabsV2ControllerUpdateRoleTab$Response(
    params: {
      id: number;
      body: WorkUpdateTaskTabDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTaskTab>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTaskTabsV2Service.TaskTabsV2ControllerUpdateRoleTabPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTaskTab>;
      })
    );
  }

  /**
   * Required permissions: task-tabs:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `taskTabsV2ControllerUpdateRoleTab$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  taskTabsV2ControllerUpdateRoleTab(
    params: {
      id: number;
      body: WorkUpdateTaskTabDto
    },
    context?: HttpContext
  ): Observable<WorkTaskTab> {
    return this.taskTabsV2ControllerUpdateRoleTab$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTaskTab>): WorkTaskTab => r.body)
    );
  }

  /** Path part for operation `taskTabsV2ControllerFindMyTab()` */
  static readonly TaskTabsV2ControllerFindMyTabPath = '/v2/task-tabs/mine/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `taskTabsV2ControllerFindMyTab()` instead.
   *
   * This method doesn't expect any request body.
   */
  taskTabsV2ControllerFindMyTab$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTaskTab>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTaskTabsV2Service.TaskTabsV2ControllerFindMyTabPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTaskTab>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `taskTabsV2ControllerFindMyTab$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  taskTabsV2ControllerFindMyTab(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkTaskTab> {
    return this.taskTabsV2ControllerFindMyTab$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTaskTab>): WorkTaskTab => r.body)
    );
  }

  /** Path part for operation `taskTabsV2ControllerDeleteMyTab()` */
  static readonly TaskTabsV2ControllerDeleteMyTabPath = '/v2/task-tabs/mine/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `taskTabsV2ControllerDeleteMyTab()` instead.
   *
   * This method doesn't expect any request body.
   */
  taskTabsV2ControllerDeleteMyTab$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTaskTabsV2Service.TaskTabsV2ControllerDeleteMyTabPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `taskTabsV2ControllerDeleteMyTab$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  taskTabsV2ControllerDeleteMyTab(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.taskTabsV2ControllerDeleteMyTab$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `taskTabsV2ControllerUpdateMyTab()` */
  static readonly TaskTabsV2ControllerUpdateMyTabPath = '/v2/task-tabs/mine/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `taskTabsV2ControllerUpdateMyTab()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  taskTabsV2ControllerUpdateMyTab$Response(
    params: {
      id: number;
      body: WorkUpdateTaskTabDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTaskTab>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTaskTabsV2Service.TaskTabsV2ControllerUpdateMyTabPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTaskTab>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `taskTabsV2ControllerUpdateMyTab$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  taskTabsV2ControllerUpdateMyTab(
    params: {
      id: number;
      body: WorkUpdateTaskTabDto
    },
    context?: HttpContext
  ): Observable<WorkTaskTab> {
    return this.taskTabsV2ControllerUpdateMyTab$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTaskTab>): WorkTaskTab => r.body)
    );
  }

  /** Path part for operation `taskTabsV2ControllerCreateMyTab()` */
  static readonly TaskTabsV2ControllerCreateMyTabPath = '/v2/task-tabs/mine';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `taskTabsV2ControllerCreateMyTab()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  taskTabsV2ControllerCreateMyTab$Response(
    params: {
      body: WorkCreateTaskTabDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTaskTab>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTaskTabsV2Service.TaskTabsV2ControllerCreateMyTabPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTaskTab>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `taskTabsV2ControllerCreateMyTab$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  taskTabsV2ControllerCreateMyTab(
    params: {
      body: WorkCreateTaskTabDto
    },
    context?: HttpContext
  ): Observable<WorkTaskTab> {
    return this.taskTabsV2ControllerCreateMyTab$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTaskTab>): WorkTaskTab => r.body)
    );
  }

}
